import AdminCrud from "@/pages/admin/components/AdminCrud";
import type { CrudField } from "@/pages/admin/components/AdminCrud";

const fields: CrudField[] = [
  { key: "name", label: "Nom", required: true },
  { key: "role", label: "Rôle" },
  { key: "bio", label: "Bio", type: "textarea" },
  { key: "image", label: "Photo (URL)", type: "image" },
];

export default function AdminEquipe() {
  return (
    <AdminCrud
      title="Équipe"
      description="Les membres de l'équipe affichés sur la page « L'association »."
      addLabel="Ajouter un membre"
      table="team_members"
      fields={fields}
      listTitleKey="name"
      listSubtitleKey="role"
      listImageKey="image"
    />
  );
}